<div class="mat-dialog-content-wrapper">
  <span class="close-button closable" (click)="redirect(false)" (keydown)="redirect(false)">
    <em class="icon-salir"></em>
  </span>
  <div mat-dialog-content>
    <div class="mat-dialog-content__image">
      <img [src]="assetsUrl + '/images/cda/icons/information.svg'" alt="alerta" class="icon-information" />
    </div>
    <div class="mat-dialog-content__title">
      <p>¿Estás seguro de querer regresar?</p>
    </div>
    <div class="mat-dialog-content__text">
      <p>
        Esto reiniciará todo el proceso
      </p>
    </div>
  </div>
</div>
<div class="mat-dialog-actions">
  <button
    class="btn btn-degraded blue"
    type="button"
    (click)="redirect(true)"
    id="confirm-back-redirection-dialog-button"
  >
    Sí, regresar
  </button>
</div>
<div class="mat-dialog-actions">
  <span
    (click)="redirect(false)"
    (keydown)="redirect(false)"
    class="span-blue"
    id="no-back-redirection-dialog-button"
  >
    No, continuar
</span>
</div>
